import * as types from './mutation-types';

export default {
  ['logout'](state, payload) {
    Object.assign(state, payload)
  },
  [types.SET_CURRENCY_LIST](state, payload) {
    state.currency.items = payload;
  },
  [types.SET_CURRENCY_LOADING](state, payload) {
    state.currency.loading = payload;
  },
  ['setLoading'](state, status) {
    state.loading = status;
  },
  ['setProjectTypes'](state, types) {
    state.projectTypes = types;
  },
  ['setBrandDetectionModels'](state, models_types) {
    state.brandDetectionModels = models_types;
  }
}
